import { CUSTOMER_ANALYTICS_EVENT } from "../../utils/enums";
import { scrollToCategorySection } from "../../utils/help/navigation/scrollToCategorySection";
import { useCustomerAnalytics } from "./useCustomerAnalytics";
import { useAppSelector } from "./useReduxHooks";

export const useCategoryBarLogic = () => {
  const addCustomerAnalytics = useCustomerAnalytics();
  const isFranchiseOpen = useAppSelector(
    (store) => store.franchiseStatus.currentIsOpen
  );
  const restaurantInfo = useAppSelector((state) => state.config.restaurantInfo);
  const isMainDark = restaurantInfo?.colors?.theme === "main_dark";

  const scrollToCategory = (
    e: React.MouseEvent<HTMLAnchorElement>,
    searchWrapperBarHeight: number
  ) => {
    e.preventDefault();
    const anchorId = e.currentTarget.getAttribute("href")?.split("#")[1];
    if (!anchorId) {
      return;
    }
    scrollToCategorySection({
      anchorId,
      searchBarHeight: searchWrapperBarHeight,
    });
  };

  const trackCategoryClick = (categoryId: number) => {
    addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.CATEGORY_BUTTON, {
      categoryId,
    });
  };

  return {
    isFranchiseOpen,
    isMainDark,
    scrollToCategory,
    trackCategoryClick,
  };
};
